const availableEventCategories = [
  {
    label: 'Não informada',
    value: null
  },
  {
    label: 'Entretenimento',
    value: 'entertainment'
  },
  {
    label: 'Corporativo',
    value: 'corporate'
  },
  {
    label: 'Trade',
    value: 'trade'
  },
  {
    label: 'Social',
    value: 'social'
  },
  {
    label: 'Esportivo',
    value: 'sports'
  },
  {
    label: 'Outros',
    value: 'others'
  }
]

export default availableEventCategories
